import { render } from "./homeIndex.vue?vue&type=template&id=2ccb3ba0"
const script = {}

import "./homeIndex.vue?vue&type=style&index=0&id=2ccb3ba0&lang=scss"
import "./homeIndex.vue?vue&type=style&index=1&id=2ccb3ba0&lang=css"

import exportComponent from "/var/jenkins_home/workspace/jk-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__